import { useFormContext } from "react-hook-form";
import { ReactNode } from "react";

const FormSubmitButton = ({ children }: { children: ReactNode }) => {
  const { formState } = useFormContext();
  return (
    <button
      className={`btn btn-primary w-full`}
      disabled={formState.isSubmitting}
    >
      {children}
    </button>
  );
};
export default FormSubmitButton;
